import {
    REVIEWS_TOUR_LANDING_START,
    REVIEWS_TOUR_LANDING_SUCCESS,
    REVIEWS_TOUR_LANDING_ERROR,
    SHOW_ALL_TOUR_REVIEW_START,
    SHOW_ALL_TOUR_REVIEW_SUCCESS,
    SHOW_ALL_TOUR_REVIEW_ERROR,
    AVERAGE_ALL_RATE_SUCCESS
} from "../Constant/TourCustomerReviewConstant"

const initialState = {
    loading: false,
    tourLandingReviewsData: [],
    tourAllReviewsdata:[],
    reviewAvgRate:0
}

export default function TourCustomerReviewsReducer(
    state = { ...initialState},
    action
) {
    switch (action.type) {
        case REVIEWS_TOUR_LANDING_START:
           return {
               ...state,
               loading: true,
           };
           case REVIEWS_TOUR_LANDING_SUCCESS:
           return {
               ...state,
               tourLandingReviewsData: action.payload,
               loading: false,
           };
           case REVIEWS_TOUR_LANDING_ERROR:
               return {
                   ...state,
                   loading: false,
                   message: action.error.message,
               };
        
            case SHOW_ALL_TOUR_REVIEW_START:
                    return {
                        ...state,
                        loading: true,
                    };
            case SHOW_ALL_TOUR_REVIEW_SUCCESS:
                    return {
                        ...state,
                        tourAllReviewsdata: action.payload,
                        loading: false,
                    };
            case AVERAGE_ALL_RATE_SUCCESS:
                    return {
                        ...state,
                        reviewAvgRate: action.payload,
                        loading: false,
                    };
            case SHOW_ALL_TOUR_REVIEW_ERROR:
                    return {
                        ...state,
                        loading: false,
                        message: action.error.message,
                    };
               default:
                   return state;
    }
}